<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Regional:"
    id="selectRegional"
    placeholder="Selecione a(s) Regional(is)"
    :multiple="false"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import RegionalRepository from '../../../../shared/http/repositories/configurations/regional'

export default {
  name: 'NxSelectRegional',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadRegionais()
  },
  methods: {
    onLoadRegionais () {
      RegionalRepository.GetAll()
        .then((response) => {
          // CURRENTLY BEEN SET VALUE=NOME UNTIL BACKEND ACCEPTS MULTIPLE
          let result = response.data.content
            .map((x) => ({'value': x.nome, 'text': x.nome}))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Regionais', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectRegional.vue